<template>
    <div>
      

             <section class="hero is-primary is-light">
				<div class="hero-body">
					<div class="container">
						<h1 class="title">Pathology Invoice Manager</h1>
						<h2 class="subtitle">List Of Invoice</h2>
                        <b-button type="is-info is-light" icon-left="plus" @click="newInvoice" >New Invoice</b-button>
					</div>
				</div>
		</section>


           <section class="mr-5 ml-5 mt-5 mb-5">
           <nav class="level is-mobile">
						<div class="level-left">
							<div class="level-item has-text-weight-semibold has-text-primary">
                                เดือนบันทึก 
							</div>
 
                            <div class="level-item has-text-primary">
                                <b-datepicker
                                                v-model="dateInvManagerWantModel"
                                                type="month"
                                                placeholder="Click to select..."
                                                icon="calendar-today"
                                                trap-focus>
                                </b-datepicker>
                            </div>


                            <div class="level-item">
                                <b-button type="is-success is-light" 
                                          class="mr-3" 
                                          icon-left="refresh"
                                          @click="loadPathoMonthInv"
                                          >Refresh</b-button>
                            </div>
						</div>
					</nav>

       </section>



        

       <section  class="mr-5 ml-5 mt-3">

        <b-tabs v-model="activeTab">
            <b-tab-item label="Table Data">
                    <template #header>
                        <b-icon icon="database-outline"></b-icon>
                        <span> Table Data <b-tag rounded type="is-info"> {{pathoMonthInvManagerArrModel.length}} </b-tag> </span>
                    </template>
                                    <b-table
                                                    :data="isEmpty ? [] : pathoMonthInvManagerArrModel "
                                                    bordered
                                                    striped
                                                    narrowed
                                                    hoverable
                                                    :loading="isTableLoading"
                                                    focusable
                                                    mobile-cards

                                                    paginated
                                                    :per-page="perPage"
                                                    :current-page.sync="currentPage"
                                                
                                            >
                            <b-table-column  label="Invoice No" centered v-slot="props">
                                
                                <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> 
                                    <!-- {{ props.row.invoice }} -->

                                    <b-dropdown aria-role="list"     >
                                                    <template #trigger>
                                                        <b-button
                                                                :type="props.row.status == -1 ? 'is-danger is-light'   : 'is-primary is-light'"
                                                                icon-right='menu-down' >
                                                                {{ props.row.invoice }}
                                                        </b-button>      
                                                    </template>

                                        <b-dropdown-item   aria-role="listitem" @click="disableInvoice(props.row)" v-if="props.row.status == 0 && props.row.receipt == null" :disabled="props.row.status == -1 || props.row.receipt != null " >ยกเลิก(disable)</b-dropdown-item>
                                        <b-dropdown-item    aria-role="listitem" v-clipboard:copy="props.row.invoice" @click="clickCopyIntoClipboard(props.row.invoice )">Copy to clipboard</b-dropdown-item>
                                    </b-dropdown>



                                </span> 
                            </b-table-column>   

                            <b-table-column  label="Total" centered v-slot="props">
                                <!-- <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ formatStringToCurrency( props.row.sum_price ) }}</span>  -->
                                <b-tooltip position="is-top" multilined   :type="props.row.status == -1 ? 'is-danger is-light'   : 'is-primary is-light'" >
                                                            <b-button  :type="props.row.status == -1 ? 'is-danger is-light'   : 'is-primary is-light'"
                                                                @click="viewDlgDetailUsedPartByInvoice(props.row.invoice)"
                                                                v-if=" props.row.sum_price > 0"
                                                                >
                                                                {{ formatStringToCurrency( props.row.sum_price ) }} 
                                                            </b-button>
                                                            <template v-slot:content>
                                                                ดูรายละเอียด <br/> <b>{{ formatStringToCurrency( props.row.sum_price )   }}</b>  
                                                            </template>
                                                        </b-tooltip>
                            </b-table-column> 


                            <b-table-column  label="Lab Member ID" centered v-slot="props">
                                <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> 
                                    {{ props.row.patho_member_id }}
                                </span> 
                            </b-table-column>        
                            <b-table-column  label="Lab Member Name" centered v-slot="props">
                                <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> 
                                    {{ props.row.patho_member_name }}
                                </span> 
                            </b-table-column>      

                            <b-table-column  label="Lab Member Address" centered v-slot="props">
                                <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> 
                                    {{ props.row.patho_member_house_address }}
                                    {{ props.row.patho_member_address_txt }}
                                    {{ props.row.patho_member_tumbon_name }}
                                    {{ props.row.patho_member_ampur_name }}
                                    {{ props.row.patho_member_province_name }}
                                </span> 
                            </b-table-column>   

                            <b-table-column  label="Lab Member Phone" centered v-slot="props">
                                <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> 
                                    {{ props.row.patho_member_phone1 }}
                                </span> 
                            </b-table-column> 

                            <b-table-column  label="Date/Time Rec." centered v-slot="props">
                                <span  :class="props.row.status != -1 ? 'is-size-6' : 'has-text-danger is-size-6' ">
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).date }}  
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).month }} 
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).year }} 
                                    </span> 
                                        
                                    <span  :class="props.row.status != -1 ? 'is-size-7 is-italic' : 'has-text-danger is-size-7 is-italic' "  >
                                        {{  getISO8601ToYearMonthDate( props.row.dt_rec ).hour }}:{{  getISO8601ToYearMonthDate( props.row.dt_rec ).minute }} 
                                    </span>  
                            </b-table-column> 


                            <b-table-column  label="User Rec." centered v-slot="props">
                                <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> 
                                    {{ props.row.user_rec_fn }}
                                </span> 
                            </b-table-column> 


                            
                            <b-table-column  label="Status" centered v-slot="props">
                                                            <b-icon
                                                                icon="circle"
                                                                :type="props.row.status != -1 ? 'is-success' : 'is-danger' "
                                                                size="is-medium">
                                                            </b-icon>
                            </b-table-column>

                            <b-table-column  label="Finish" centered v-slot="props">
                                                            <b-icon
                                                                icon="check"
                                                                type= 'is-info'  
                                                                size="is-medium"
                                                                v-if="props.row.receipt != null"
                                                                >
                                                            </b-icon>
                            </b-table-column>


                            <b-table-column  label="Mark To Finish" centered v-slot="props">
                                        <b-button type="is-info" icon-left="cloud-upload"
                                        @click="markToFinish(props.row)"
                                        :disabled="props.row.receipt != null || props.row.status == -1"
                                        >Mark To Finish</b-button>           
                            </b-table-column>


                                    </b-table>
            </b-tab-item>
<!-- Invoice Statistics" -->
            <b-tab-item label="Summary" >
                 <template #header>
                        <b-icon icon="sigma"></b-icon>
                        <span> Summary </span>
                    </template>
                <StatisticsPathoInvoiceManager />
            </b-tab-item>    
        </b-tabs>    
		
       </section>


       <b-modal
                    v-if="isDlgDetailUsedPartByInvoiceShowing"
                    v-model="isDlgDetailUsedPartByInvoiceShowing"
                    has-modal-card   
                    full-screen
                    :can-cancel="true">
                <DlgDetailUsedPartByInvoice v-if="isDlgDetailUsedPartByInvoiceShowing"
                         :isShowing ="isDlgDetailUsedPartByInvoiceShowing"
                         :dataProp = "dataPropDlgDetailUsedpart_Invoice"
                         @close="closeDlgDetailUsedPartByInvoice"
                         
                        
                />
        </b-modal>



    </div>
</template>


<script>
import { mapMutations , mapState , mapActions } from 'vuex'
import axios from "axios";
import { getBaseURLforBackEnd , getConfigAxios  } from '@/utils.js'
import getISO8601ToYearMonthDate from '../../../mixins/methods/getISO8601ToYearMonthDate'
import formatStringToCurrency from '../../../mixins/methods/formatStringToCurrency'
import DlgDetailUsedPartByInvoice from '../DlgDetailUsedPartByInvoice.vue'
import StatisticsPathoInvoiceManager from '../Invoice/StatisticsPathoInvoiceManager.vue'

export default {
    name : "PathoInvoiceManager",
    mixins:[formatStringToCurrency,getISO8601ToYearMonthDate,],
    components:{
        DlgDetailUsedPartByInvoice,
        StatisticsPathoInvoiceManager,
    },
    mounted(){
    
		if(this.dateInvManagerWant == null){
            this.loadCurrentDate()
                 .then(()=>{
                     if(this.pathoMonthInvManagerArrModel.length==0 &&  this.dateInvManagerWant != null ){
                        this.isTableLoading = true
                        this.fetchPathoMonthInvManager()
                            .then(()=>{
                                this.isTableLoading = false
                            }) 
                     }
                 })
       
        }

         
	},



    computed:{
        ...mapState({
            access_token : state => state.master_data.access_token ,

            pathoMonthInvManagerArr : state => state.patho_invoice.pathoMonthInvManagerArr ,
            dateInvManagerWant: state => state.patho_invoice.dateInvManagerWant ,
		}),

        pathoMonthInvManagerArrModel:{
                get: function () {
                    return this.pathoMonthInvManagerArr
                },
                set: function (newValue) {
                    this.setDateInvManagerWant(newValue)
                }
        },
        dateInvManagerWantModel:{
                get: function () {
                    return this.dateInvManagerWant
                },
                set: function (newValue) {
                    this.setDateInvManagerWant(newValue)
                }
        },



    },
    methods:{
         ...mapMutations({
                setPathoMonthInvManagerArr : 'patho_invoice/setPathoMonthInvManagerArr',
                setDateInvManagerWant : 'patho_invoice/setDateInvManagerWant',
        }), 

        ...mapActions({
                fetchPathoMonthInvManager : 'patho_invoice/fetchPathoMonthInvManager',
        }),

        markToFinish(payload){
        //    console.log(payload)
        //    to_mark_patho_receipt

            this.isTableLoading = true
            const datTo =     {
                    "invoice_no" : payload.invoice
                }
            axios.defaults.headers.common['Authorization'] =  `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/to_mark_patho_receipt`,datTo,getConfigAxios())  
                 .then((res)=>{
                     const tmp =  this.pathoMonthInvManagerArrModel.find(dat=>dat.invoice == payload.invoice)
                     tmp.receipt = res.data.receipt_id
                     this.isTableLoading = false 
                 }) 




        },
        viewDlgDetailUsedPartByInvoice(_invoice_no){
           this.dataPropDlgDetailUsedpart_Invoice = _invoice_no 
           this.isDlgDetailUsedPartByInvoiceShowing = true  
        },
        closeDlgDetailUsedPartByInvoice(){
           this.isDlgDetailUsedPartByInvoiceShowing = false  
        },
        clickCopyIntoClipboard(_id){
              this.$buefy.toast.open({
                    duration: 2000,
                    message: `Copy <b>${_id}</b> to clipboard`,
                    position: 'is-bottom',
                    type: 'is-primary is-light'
                })
        }, 



        disableInvoice(_data){
            // console.log(_data)
            this.isTableLoading = true
            const datTo =     {
                    "invoice_no" : _data.invoice
                }
            axios.defaults.headers.common['Authorization'] =  `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/disable_patho_invoice`,datTo,getConfigAxios())  
                 .then(()=>{
                     const tmp =  this.pathoMonthInvManagerArrModel.find(dat=>dat.invoice == _data.invoice)
                     tmp.status = -1
                     this.isTableLoading = false 
                 }) 
        },
        loadPathoMonthInv(){
            this.isTableLoading = true
            this.fetchPathoMonthInvManager()
                .then((res)=>{
                    this.$buefy.snackbar.open({
                                duration: 1000,
                                message: `fetch data complete.<br><em>${res.length}</em> Records`,
                                type: 'is-danger',
                                position: 'is-bottom-left',
                                // actionText: 'Undo',
                                queue: false,
                             
                    })

                    this.isTableLoading = false
                    this.currentPage = 1
                    this.activeTab = 0
                })
        },
        newInvoice(){
        //   preparemakeinvoice
        //    this.$router.push(`/preparemakeinvoice`)
        //                 .catch(()=>{});
        this.$router.push(`/preparemakeinvoice_searchitems`)
                        .catch(()=>{});
        },
        loadCurrentDate(){
             return new Promise((resolve) => {  
                                            axios.get(`${getBaseURLforBackEnd()}/api/curdatetime` ,getConfigAxios())
                                                .then( (response) => {
                                                            this.dateInvManagerWantModel = new Date( Date.parse(response.data.current_datetime)) 
                                                            resolve(response)
                                                        }) 
                })

        }, 
    },
    data(){
        return{
           isEmpty : false,
           isTableLoading : false,

           isDlgDetailUsedPartByInvoiceShowing : false,
           dataPropDlgDetailUsedpart_Invoice : "", // pass invoce_no

           perPage : 20,
           currentPage : 1,
           
           activeTab : 0,
        }
    }
}
</script>